import type {CreateExtArgs, EnvironmentContext} from '@wix/document-manager-core'
import type {CompRef} from '@wix/document-services-types'
import {generateAndInjectImages} from './utils'
import {type EditImageParams, fetchEditedImages} from './requests'

export const editImages = async (
    environmentContext: EnvironmentContext,
    createExtArgs: CreateExtArgs,
    componentPointers: CompRef[],
    userPrompt: string
): Promise<void> => {
    return generateAndInjectImages<EditImageParams>(
        environmentContext,
        createExtArgs,
        componentPointers,
        (_key, url, width, height) => ({
            width_RunwareFlux: width.toString(),
            height_RunwareFlux: height.toString(),
            userImage: url,
            editRequest: userPrompt
        }),
        fetchEditedImages
    )
}
